//@ts-check
/**
 * The cover the app opens under (wip-archive/app-start/APP_START.md, step 2): plain cream, the
 * colour of the iOS launch screen, carried on by the web app until the first screen is ready, then
 * faded away once — so Home is shown as it will stay, not put together section by section in front
 * of you.
 *
 * Ready is Home's data answered, or failed (`$lib/home.js`), or, on any other screen of the app,
 * the session confirmed. Capped, so a slow connection never leaves the app behind a blank screen:
 * past `CAP_MS` from the page's start, whatever is there shows. Once lifted it never comes back.
 *
 * Only the signed-in screens are covered (`StartCover.svelte`, in the root layout); the rest lift
 * it at once.
 */
import { markStart } from "$lib/startprobe.js";

/** The longest the cover stays up, in ms from the page's start. */
const CAP_MS = 2500;

export const cover = $state({ up: true });

/** Lift the cover; the first call only. */
export function liftCover() {
  if (!cover.up) return;
  cover.up = false;
  markStart("ready");
}

/** Called once, by the root layout on mounting: lifts the cover at the cap, if nothing has. */
export function capCover() {
  setTimeout(liftCover, Math.max(0, CAP_MS - performance.now()));
}
